export default __webpack_public_path__ + "static/media/star-half.0dba878f.svg";